import React from 'react';

const TypingIndicator = ({ isTyping }) => {
  if (!isTyping) return null;

  return (
    <div className="typingIndicatorBar">
      <div className="typingDots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      AI Mentor is thinking...
    </div>
  );
};

export default TypingIndicator;
